module.exports = "\r\n<h1>Chọn trở lại sau khi in xong</h1>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/printhd/printhd.component.html
// module id = ./src/app/components/printhd/printhd.component.html
// module chunks = main